(function () {
  if (window.__nativeScentsSectionInitialized) {
    return;
  }
  window.__nativeScentsSectionInitialized = true;

  var SECTION_SELECTOR = '[data-section-type="scents-section"]';
  var INITIALIZED_ATTR = 'scentsSectionInitialized';
  var cleanupMap = new WeakMap();

  var findSections = function (root) {
    if (!root || !root.querySelectorAll) {
      return [];
    }
    return Array.prototype.slice.call(root.querySelectorAll(SECTION_SELECTOR));
  };

  var toggleCardState = function (card, expand) {
    var cardVariants = card.querySelector('.scents-section__scent-variants-wrapper');
    var cardDescription = card.querySelector('.scents-section__scent-card-cover-description');
    var cardCloseButton = card.querySelector('.button-close');

    cardVariants.classList.toggle('expanded', expand);
    cardVariants.classList.toggle('collapsed', !expand);

    cardDescription.style.opacity = expand ? 0 : 1;
    cardDescription.style.height = expand ? 0 : 'auto';

    cardCloseButton.classList.toggle('button-close-expanded', expand);
    cardCloseButton.classList.toggle('button-close-collapsed', !expand);
  };

  var closeAllCards = function () {
    var cardsOpened = document.querySelectorAll('.scents-section__scent-variants-wrapper.expanded');
    cardsOpened.forEach(function (cardOpened) {
      var parentCard = cardOpened.closest('[data-card-id]');
      toggleCardState(parentCard, false);
    });
  };

  var getScentScrollOffset = function () {
    var header = document.querySelector('#header-section');
    var tabs = document.querySelector('.scents-section-tabs');
    var headerHeight = header ? header.offsetHeight : 0;
    var tabsHeight = tabs ? tabs.offsetHeight : 0;
    return headerHeight + tabsHeight + 8;
  };

  var scrollCardIntoView = function (card) {
    if (!card) {
      return;
    }
    var offset = getScentScrollOffset();
    var cardTop = card.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: cardTop, behavior: 'smooth' });
  };

  var openTab = function (cardId) {
    var card = document.querySelector('[data-card-id="' + cardId + '"]');
    if (!card) {
      return;
    }
    var cardVariants = card.querySelector('.scents-section__scent-variants-wrapper');

    var isCollapsed = cardVariants.classList.contains('collapsed');
    var isExpanded = cardVariants.classList.contains('expanded');

    if (isCollapsed) {
      closeAllCards();
      toggleCardState(card, true);
      updateUrlForCard(card);
    } else if (isExpanded) {
      toggleCardState(card, false);
    }
  };

  var updateUrlForCard = function (card) {
    if (!card || !card.getAttribute) {
      return;
    }
    var slug = card.getAttribute('data-slug');
    if (!slug) {
      return;
    }
    var params = new URLSearchParams(window.location.search);
    params.set('family', slug);
    var newUrl = window.location.pathname + '?' + params.toString();
    window.history.replaceState({}, '', newUrl);
  };

  var scrollToScentCard = function (cardId) {
    var card = document.querySelector('[data-card-id="' + cardId + '"]');
    if (!card) {
      return;
    }

    var cardVariants = card.querySelector('.scents-section__scent-variants-wrapper');
    var shouldExpand = cardVariants && cardVariants.classList.contains('collapsed');

    if (shouldExpand) {
      closeAllCards();
      toggleCardState(card, true);
    }

    updateUrlForCard(card);
    scrollCardIntoView(card);
  };

  // Make functions globally available for onclick handlers
  window.openTab = openTab;
  window.scrollToScentCard = scrollToScentCard;

  var initializeSection = function (section) {
    if (!section || section.dataset[INITIALIZED_ATTR] === 'true') {
      return;
    }
    section.dataset[INITIALIZED_ATTR] = 'true';

    var listeners = [];
    var addListener = function (target, eventName, handler) {
      if (!target) {
        return;
      }
      target.addEventListener(eventName, handler);
      listeners.push(function () {
        target.removeEventListener(eventName, handler);
      });
    };

    // Initialize any event listeners if needed in the future
    // For now, the onclick handlers in the HTML will use the global openTab function

    var cleanup = function () {
      listeners.forEach(function (unsubscribe) {
        unsubscribe();
      });
      listeners = [];
      delete section.dataset[INITIALIZED_ATTR];
      cleanupMap.delete(section);
    };

    cleanupMap.set(section, cleanup);
  };

  var destroySection = function (section) {
    if (!section) {
      return;
    }
    var cleanup = cleanupMap.get(section);
    if (cleanup) {
      cleanup();
    }
  };

  var initAll = function (root) {
    findSections(root || document).forEach(initializeSection);
  };

  var expandFromUrl = function () {
    var params = new URLSearchParams(window.location.search);
    var slugParam = params.get('family');
    if (!slugParam) {
      return;
    }

    var decodedSlug = decodeURIComponent(slugParam);

    // Small delay to ensure all cards are rendered
    setTimeout(function () {
      var card = document.querySelector('[data-slug="' + decodedSlug + '"]');

      if (card) {
        var cardId = card.getAttribute('data-card-id');
        scrollToScentCard(cardId);
      } else {
        console.warn('Scent family not found:', decodedSlug);
      }
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      expandFromUrl();
    });
  } else {
    initAll();
    expandFromUrl();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) {
      return;
    }
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = null;
    if (event && event.detail && event.detail.sectionId) {
      var wrapper = document.getElementById('shopify-section-' + event.detail.sectionId);
      if (wrapper) {
        section = wrapper.querySelector(SECTION_SELECTOR);
      }
    }
    if (!section && event && event.target) {
      if (event.target.matches && event.target.matches(SECTION_SELECTOR)) {
        section = event.target;
      } else if (event.target.querySelector) {
        section = event.target.querySelector(SECTION_SELECTOR);
      }
    }
    destroySection(section);
  });
})();
